import { Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SettingsPage from './pages/settings/SettingsPage';
import ChangePasswordPage from './pages/settings/ChangePasswordPage';
import UpdateEmailPage from './pages/settings/UpdateEmailPage';
import PrivateRoute from './components/PrivateRoute';
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ScrollToTop from "./components/ScrollToTop";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SignUpPage from "./pages/SignUpPage";
import InidividualSite from "./pages/InidividualSitePage";
import PatrolPlan from "./pages/PatrolPlanPage";
import ChooseLocations from "./pages/ChooseLocationsPage";


function App() {
  return (
    <MainLayout>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
        <Route path="/settings/change-password" element={<PrivateRoute><ChangePasswordPage /></PrivateRoute>} />
        {/* <Route path="/settings/update-email" element={<PrivateRoute><UpdateEmailPage /></PrivateRoute>} /> */}
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/register" element={<SignUpPage />} />
        <Route path="/patrolplan" element={<PatrolPlan />} />
        <Route path="/patrolplan/:siteid/:sitename" element={<InidividualSite />} />
        <Route path="/choose-locations" element={<ChooseLocations />} />
      </Routes>
    </MainLayout>
  );
}

export default App;
